import { render, staticRenderFns } from "./voice.vue?vue&type=template&id=7fe3c98d&scoped=true&"
import script from "./voice.vue?vue&type=script&lang=js&"
export * from "./voice.vue?vue&type=script&lang=js&"
import style0 from "./voice.vue?vue&type=style&index=0&id=7fe3c98d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe3c98d",
  null
  
)

export default component.exports